import { render, staticRenderFns } from "./ClientsCard.vue?vue&type=template&id=4ce6b4c4"
import script from "./ClientsCard.vue?vue&type=script&lang=js"
export * from "./ClientsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports